import { Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';

import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeData } from '../rootscope-data';
import { environment } from '../../../environments/environment';
import { FacilityService } from '../services/facility.service';
import { FacilityObject } from '../services/facility.model';


declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class RootScopeService {
  rootScopeDataObj = new BehaviorSubject<RootScopeDeclare>(RootScopeData);
  scrolled$ = new Subject<void>();

  constructor(private _facilityService: FacilityService) {
    this.updateRootScope(RootScopeData);
  }

  getRootScope(): Observable<RootScopeDeclare> {
    let tmpRootScopeDataObj = this.rootScopeDataObj.value;
    tmpRootScopeDataObj = this.prepareConsoleRights(tmpRootScopeDataObj);
    this.updateRootScope(tmpRootScopeDataObj);
    return this.rootScopeDataObj.asObservable();
  }

  updateRootScope(rootscope: RootScopeDeclare) {
    this.rootScopeDataObj.next(rootscope);
  }

  //Below is the custom logic to transform the console right.
  prepareConsoleRights(rootScopeData: RootScopeDeclare) {
    rootScopeData.consoleRights.forEach(val => {
      if (val.hasInternetSetting === 'true' || val.hasTVSetting === 'true') {
        val.hasEntertainment = 'true';
      } else {
        val.hasEntertainment = 'false';
      }
    })
    return rootScopeData;
  }

  changeToRtl(): void {
    $('head').append('<link rel="stylesheet" type="text/css" href="' + environment.assetsPath + '/css/rtl.css"/>');
    RootScopeData.isRTL = true;
  }

  changeToLtr(): void {
    $('link[href*="rtl.css"]').remove();
    RootScopeData.isRTL = false;
  }

  countryCheck(countryIsoCodes: string[]): Promise<string> {
    return new Promise((resolve, reject) => {
      this._facilityService.selectedFacilitySource.subscribe(
        (res: FacilityObject) => {
          if (
            res &&
            res['summary'] &&
            res['summary']['countryIsoCode'] &&
            countryIsoCodes.includes(res.summary.countryIsoCode)
          ) {
            resolve(res.summary.countryIsoCode);
          } else {
            reject(null);
          }
        },
        (err: any) => {
          reject(null);
        }
      );
    });
  }
}
